export default __webpack_public_path__ + "static/logo-small-1a7e1efa0c1a6464958fe8c82be4f86e.svg";